import React from 'react';
import $ from 'jquery';
import { RegionService } from './../../services/region.service';
import { VolumeService } from './../../services/volume.service';
import ReactToolTip from 'react-tooltip';
import { isPositiveNonZero, getUnique } from '../../utility/utility';
import { AuditLog } from './../../services/auditlog.service';
import { getMessage } from '../../constants/messagesMapper';
import { FlavorService } from './../../services/flavor.service';

class Volumes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfig: false,
            extendShow: false,
            attachShow: false,
            isDeletePopup: false,
            volumeList: [],
            actionVolumeList: [],
            selectVolumeList: [],
            regionList: [],
            errorMessg: '',
            isCreate: true,
            selectedVolume: {},
            renameName: '',
            volumeRegionUrl: '',
            extendVolume: '',
            volumeName: '',
            selectedVolumeId: '',
            selectVolume: '',
            columnType: 'name',
            nameToggle: true,
            dateToggle: false,
            sizeToggle: false,
            regionVolumes: [],
            size: '',
            nameErrorMessg: '',
            sizeErrorMessg: '',
            isCreateAction: false,
            isYearly: true,
            discId: "",
            discCode: "",
            discPerce: "",
            discVal: "",
            volPrice: 0.1
        };
    }
    componentDidMount() {
        $("html").animate({ scrollTop: 0 }, "slow");
        this.setDiscount();
        this.setVolumeRegionUrl();
        this.setCurentRegionVolumes();
    }
    componentWillUnmount() {
        this.props.msgHandler("");
    }
    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };

    setDiscount() {
        FlavorService.getDiscounts().then(resp => {
            if(Array.isArray(resp)) {

                for(let i = 0; i < resp.length; i++) {
                    if(resp[i].code_type == "cloud") {
                        let ob = resp[i];
                        this.setState({ discId: ob.id, discCode: ob.code, discPerce: ob.discount, discVal: 100 / ob.discount });
                    }

                }

            }
        });
    }
    setVolumeRegionUrl() {
        RegionService.getByProject('volumev3').then(resp => {
            if(resp && resp.length > 0) {
                this.setState({ volumeRegionUrl: resp.find(item => item.region === this.props.instance.region).url });
            }
        }).catch(error => {
            this.props.msgHandler("Error while fetching volumes, Please try again later", "error");
            this.clearToastMessage();
        });
    };

    setCurentRegionVolumes() {
        this.props.bgShadowHandler(true);
        VolumeService.getByRegionId(this.props.instance.region).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp && resp.length > 0) {
                let regionVolumeList = resp;
                if(regionVolumeList.length > 0) {
                    let volumes = [];
                    let actionVolumes = [];
                    regionVolumeList.forEach(item => {
                        if(item.attachments.length > 0 && item.attachments[0].server_id === this.props.instance.id) {
                            volumes.push(item);
                        } else if(item.status === 'available') {
                            actionVolumes.push(item);
                        }
                    });
                    this.setState({ volumeList: this.getSortableData(this.state.columnType, volumes), actionVolumeList: actionVolumes, regionVolumes: regionVolumeList });
                }
            }
        });
    }

    onRowMenuClick = (event, volume) => {
        if(!this.props.isTaskStateNull) {
            return;
        }
        this.setState({ selectedVolume: volume });
        $(event.currentTarget).closest('.tr').find('.dropdown_component ').toggleClass('active');
    };

    addVolume() {
        let i18n = this.props.i18n;
        if(this.checkVolumeSize()) {
            this.props.msgHandler(i18n.t('inst_max_vol_attach'), 'warning');
            return;
        }
        let volumes = this.state.actionVolumeList.filter(item => item.status === 'available');
        if(volumes.length > 0) {
            volumes = getUnique(volumes, 'id');
        }
        $('.createVolume_slider').addClass('active');
        $("body").addClass("no_scroll");
        $('#existingVolume').removeClass('active');
        //$('#createVolume').removeClass('active');
        $('#createVolume').addClass('active');

        this.setState({ selectVolumeList: volumes, isYearly: true, errorMessg: '', isCreate: true, volumeName: '', size: '', attachErrorMessg: '', nameErrorMessg: '', sizeErrorMessg: '' });
        setTimeout(() => document.getElementById('volumeName').focus(), 500);
    }

    showConfiguration = (event) => {
        this.setState({ showConfig: true });
    };

    isNameExist = (name) => {
        let ob = this.state.regionVolumes.find(item => item.name === name.trim());
        if(ob !== undefined) {
            return true;
        }
        return false;
    };

    formHandler = (event) => {
        let name = event.target.name;
        let val = event.target.value;

        if(name === 'selectVolume') {
            if(val !== '') {
                let volume = this.state.selectVolumeList.find(item => item.id === val);
                this.setState({ selectVolume: volume.name, selectedVolumeId: val, attachErrorMessg: '' });
            } else {
                this.setState({ selectVolume: val, selectedVolumeId: val, attachErrorMessg: '' });
            }
            return;
        }
        if(name === 'size' && val !== '') {
            if(!isPositiveNonZero(val)) {
                return;
            }
            if(val > 1000) {
                return;
            }
        }
        if((name === 'volumeName' || name === 'renameName') && val.length > 20) {
            return;
        }

        this.setState({ [name]: val, errorMessg: '', nameErrorMessg: '', sizeErrorMessg: '', attachErrorMessg: '' });
    };

    onVolKeydown = (e, type) => {
        if(e.keyCode === 13) {
            if(type === 'addvolume') {
                this.createAndAttachVolume();
            } else if(type === 'rename') {
                this.renameVolume();
            }
        }
    };

    renameVolume() {
        let volName = this.state.renameName.trim();
        let oldVolumeName = this.state.selectedVolume.name;
        if(volName === undefined || volName === '' || oldVolumeName === volName) {
            this.setState({ errorMessg: 'Volume name is mandatory to rename the volume' });
            document.getElementById('renameName').focus();
            return;
        }
        // else if(this.isNameExist(volName)) {
        //     this.setState({ nameErrorMessg: 'Volume name should not be duplicate' });
        //     document.getElementById('renameName').focus();
        //     return;
        // }
        this.props.bgShadowHandler(true);
        this.renameClose();
        this.setState({ errorMessg: '' });
        let requestBody = {
            volume: {
                name: volName
            }
        };

        let i18n = this.props.i18n;
        VolumeService.updateVolumeById(this.state.selectedVolume.id, requestBody, this.state.volumeRegionUrl, this.props.instance.region).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp && resp.volume) {
                let volume = resp.volume;
                let volumeList = this.state.volumeList;
                let index = volumeList.findIndex(item => item.id === volume.id);
                volume.region = this.state.selectedVolume.region;
                volumeList[index] = volume;
                this.updateRegionVolume(volume);
                this.setState({ selectedVolume: volume, volumeList: volumeList });
                const volumeBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume rename from " + oldVolumeName + " to " + requestBody.volume.name,
                    "operation": "Volume Rename",
                    "region": this.props.instance.region
                };
                AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.msgHandler(i18n.t('vol_rename_success'), 'success');
                this.clearToastMessage();
                return;
            }
            if(resp && typeof resp === 'string') {
                this.props.msgHandler(resp, 'error');
                this.clearToastMessage();
                return;
            }
            this.props.msgHandler(i18n.t('vol_rename_failure'), 'error');
            this.clearToastMessage();
        });
    }

    updateRegionVolume(volume) {
        let regionVolumes = this.state.regionVolumes;
        let index = regionVolumes.findIndex(item => item.id === volume.id);
        regionVolumes[index] = volume;
        this.setState({ regionVolumes: regionVolumes });
    }

    extendVolumeSize() {
        let selectedVolume = this.state.selectedVolume;
        let extendVolume = this.state.extendVolume;
        if(extendVolume === undefined || extendVolume === '') {
            this.setState({ errorMessg: 'Please provide size to extend the volume' });
            return;
        } else if(extendVolume <= selectedVolume.size) {
            this.setState({ errorMessg: 'New size for extend must be greater than current size of ' + selectedVolume.size + ' GB' });
            return;
        }
        this.props.bgShadowHandler(true);
        this.setState({ extendShow: false, errorMessg: '' });
        let requestBody = {
            "os-extend": {
                "new_size": parseInt(extendVolume)
            }
        };
        VolumeService.doVolumeActionById(selectedVolume.id, requestBody, this.state.volumeRegionUrl).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp === null) {
                let volume = selectedVolume;
                volume.size = parseInt(extendVolume);
                let volumeList = this.state.volumeList;
                let index = volumeList.findIndex(item => item.id === volume.id);
                volumeList[index] = volume;
                this.setState({ selectedVolume: volume, volumeList: volumeList, });
                this.props.msgHandler('Successfully exteded the Volume!', '');
                this.clearToastMessage();
                return;
            }
            if(resp && typeof resp === 'string') {
                this.props.msgHandler(resp, 'error');
                this.clearToastMessage();
                return;
            }
            this.props.msgHandler('Failed to rename the Volume. Please try Again', 'error');
            this.clearToastMessage();
        });
    }

    detachInstance() {
        this.props.bgShadowHandler(true);
        this.detachClose();
        let instanceId = this.props.instance.id;
        let volumeId = this.state.selectedVolume.id;
        let i18n = this.props.i18n;
        let region = this.props.instance.region;
        let volumeName = this.state.selectedVolume.name;
        let instanceName = this.props.instance.name;
        VolumeService.detachInstanceById(instanceId, volumeId,
            this.props.computeRegionUrl, region).then(resp => {
                this.props.bgShadowHandler(false);
                if(resp === null) {
                    const volumeBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Volume " + volumeName + " has been detached from the instance " + instanceName,
                        "operation": "Volume Detach",
                        "region": region
                    };
                    AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                        if(resp === false);
                    });
                    this.removeAttachment(volumeId);
                    this.props.msgHandler(i18n.t('inst_vol_detach_success'), 'success');
                    this.clearToastMessage();
                    return;
                }
                if(resp && typeof resp === 'string') {
                    this.props.msgHandler(resp, 'error');
                    this.clearToastMessage();
                    return;
                }
                this.props.msgHandler(i18n.t('inst_vol_detach_failure'), 'error');
                this.clearToastMessage();
            });
    }

    deleteVolumeById() {
        this.props.bgShadowHandler(true);
        this.setState({ isDeletePopup: false });
        let selectedVolumeId = this.state.selectedVolume.id;
        VolumeService.deleteVolumeById(selectedVolumeId, this.state.volumeRegionUrl, this.props.instance.region).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp === null) {
                let volumes = this.state.volumeList;
                let index = volumes.findIndex(item => item.id === selectedVolumeId);
                volumes.splice(index, 1);
                this.setState({ volumeList: volumes });
                this.props.msgHandler('Successfully deleted the Volume', '');
                this.clearToastMessage();
                return;
            }
            this.props.msgHandler('Failed to delete the Volume. Please Try Again', 'error');
            this.clearToastMessage();
        });
    }

    checkVolumeSize() {
        if(this.state.volumeList.length === 25) {
            return true;
        }
        return false;
    }

    createAndAttachVolume() {
        let volName = this.state.volumeName.trim();
        if(volName === undefined || volName === '') {
            document.getElementById('volumeName').focus();
            this.setState({ nameErrorMessg: 'Volume name is mandatory to create new volume' });
            return;
        } else if(this.state.size === undefined || this.state.size === '') {
            this.setState({ sizeErrorMessg: 'Volume size is mandatory to create new volume' });
            document.getElementById('size').focus();
            return;
        } else if(this.state.size > 1000) {
            this.setState({ errorMessg: 'Volume size should not be more than 1000 GB' });
            return;
        }
        else if(this.state.isYearly) {
            if(this.state.size < 10) {
                this.setState({ sizeErrorMessg: 'Minimum volume size required: 10 GB' });
                document.getElementById('size').focus();
                return;
            }
        }
        // else if(this.isNameExist(volName)) {
        //     this.setState({ nameErrorMessg: 'Volume name should not be duplicate' });
        //     document.getElementById('volumeName').focus();
        //     return;
        // }
        if(this.state.isCreateAction) {
            return;
        }
        this.setState({ errorMessg: '', isCreateAction: true });
        // else if(this.state.size < 10) {
        //     this.setState({ sizeErrorMessg: 'Size should be more than 10 GB' });
        //     document.getElementById('size').focus();
        //     return;
        // }
        let i18n = this.props.i18n;
        let requestBody = {
            volume: {
                size: this.state.size,
                name: volName
            }
        };
        let logRegion = this.props.instance.region;

        this.props.bgShadowHandler(true);
        VolumeService.createVolume(requestBody, logRegion, this.state.isYearly).then(resp => {
            if(resp === "PAYMENT_ERROR") {
                this.props.bgShadowHandler(false);
                this.props.msgHandler("An error occurred while processing the card details.You can try again by adding another card or after sometime.");
                this.setState({ isAction: false, isCreateAction: false });
                this.clearToastMessage();
                return;
            }
            if(resp && resp.volume) {
                const volumeBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume " + volName + " has been created ",
                    "operation": "Volume created",
                    "region": this.props.instance.region
                };
                AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.addNewVolume(resp.volume);
                this.attachVolumetoInstance(resp.volume);
                this.addVolumeClose();
                this.setState({ volumeName: '', size: '' });
                return;
            }
            this.props.bgShadowHandler(false);
            this.props.msgHandler(i18n.t('vol_create_failure'), 'error');
            this.clearToastMessage();
            this.setState({ isAction: false, isCreateAction: false });
        });

    }

    attachVolumetoInstance(volume) {
        let volumeId = '';
        if(volume === undefined) {
            if(this.state.selectVolumeList.length == 0) {
                this.setState({ attachErrorMessg: 'No volume is available to attach to this instance' });
                return;
            }
            volumeId = this.state.selectedVolumeId;
            if(volumeId === undefined || volumeId === '') {
                this.setState({ attachErrorMessg: 'Please select the volume to attach to this instance' });
                return;
            }
            volume = this.state.selectVolumeList.find(item => item.id === this.state.selectedVolumeId);
            this.props.bgShadowHandler(true);
        } else {
            volumeId = volume.id;
        }
        let i18n = this.props.i18n;
        let compRegionUrl = this.props.computeRegionUrl;
        let instanceName = this.props.instance.name;
        VolumeService.attachInstanceById(this.props.instance.id, volumeId,
            compRegionUrl, this.props.instance.region).then(resp => {
                if(resp && resp.volumeAttachment) {
                    const volumeBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Volume " + volume.name + " has been attached to instance " + instanceName,
                        "operation": "Volume Attach",
                        "region": this.props.instance.region
                    };
                    AuditLog.storeAuditLogs(volumeBody, "instance").then((resp) => {
                        if(resp === false);
                    });
                    this.attachAttachment(volume, resp.volumeAttachment);
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler(i18n.t('inst_vol_attach_success'), 'success');
                    this.clearToastMessage();
                    this.addVolumeClose();
                    this.setState({ selectedVolume: '', selectedVolumeId: '', isCreateAction: false });
                    return;
                }
                if(resp && resp.badRequest && resp.badRequest.message) {
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler(getMessage(resp.badRequest.message), 'error');
                    this.clearToastMessage();
                    return;
                }
                if(resp && typeof resp === 'string') {
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler(resp, 'error');
                    this.clearToastMessage();
                    return;
                }
                this.props.bgShadowHandler(false);
                this.props.msgHandler(i18n.t('inst_vol_attach_failure'), 'error');
                this.clearToastMessage();
                this.setState({ isCreateAction: false });
            });
    }

    attachAttachment(volume, volResp) {
        let volumes = this.state.volumeList.filter(item => item.id !== volume.id);
        let regionVolumes = this.state.regionVolumes.filter(item => item.id !== volume.id);
        let actionVolumes = this.state.actionVolumeList.filter(item => item.id !== volume.id);
        volume.status = 'in-use';
        volume.attachments = [{
            device: volResp.device,
            id: volResp.volumeId,
            server_id: volResp.serverId,
            volume_id: volResp.volumeId
        }];
        volumes.push(volume);
        regionVolumes.push(volume);
        this.setState({ volumeList: this.getSortableData(this.state.columnType, volumes), regionVolumes: regionVolumes, actionVolumeList: actionVolumes });
    }

    addNewVolume(volume) {
        let regionVolumes = this.state.regionVolumes;
        let actionVolumes = this.state.actionVolumeList;
        volume.status = 'available';
        actionVolumes.push(volume);
        regionVolumes.push(volume);
        this.setState({ regionVolumes: regionVolumes, actionVolumeList: actionVolumes });
    }

    removeAttachment(volumeId) {
        let volumes = this.state.volumeList;
        let actionVolumes = this.state.actionVolumeList;
        let index = volumes.findIndex(item => item.id === volumeId);
        let volume = volumes[index];
        volume.status = 'available';
        volume.attachments = [];
        actionVolumes.push(volume);
        volumes.splice(index, 1);
        this.setState({ volumeList: volumes, actionVolumeList: actionVolumes });
    }

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (type) => {
        if(type === "name") {
            this.setState({ nameToggle: !this.state.nameToggle }, () => this.setState({ volumeList: this.getSortableData(type, this.state.volumeList) }));
        } else if(type === "date") {
            this.setState({ dateToggle: !this.state.dateToggle }, () => this.setState({ volumeList: this.getSortableData(type, this.state.volumeList) }));
        } else if(type === "size") {
            this.setState({ sizeToggle: !this.state.sizeToggle }, () => this.setState({ volumeList: this.getSortableData(type, this.state.volumeList) }));
        }
    };

    getSortableData = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        this.setState({ columnType: type });
        if(type === "name") {
            if(this.state.nameToggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            //this.setState({ nameToggle: !this.state.nameToggle});
            return items;
        }
        else if(type === "date") {
            if(this.state.dateToggle) {
                items.sort(function (a, b) {
                    return new Date(a.created_at) - new Date(b.created_at);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                });

            }
            //this.setState({ dateToggle: !this.state.dateToggle })
            return items;
        }
        else if(type === "size") {
            if(this.state.sizeToggle) {
                items.sort(function (a, b) {
                    if(a.size < b.size) { return 1; }
                    if(a.size > b.size) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.size < b.size) { return -1; }
                    if(a.size > b.size) { return 1; }
                    return 0;
                });


            }
            //this.setState({ sizeToggle: !this.state.sizeToggle})
            return items;
        }
        return items;
    };

    addVolumeClose = () => {
        $('.createVolume_slider').removeClass('active');
        $("body").removeClass("no_scroll");
        this.setState({
            isYearly: true
        });
    };

    renameClick = () => {
        $('.renameVolume_slider').addClass('active');
        this.setState({ errorMessg: '', renameName: this.state.selectedVolume.name });
        setTimeout(() => {
            document.getElementById('renameName').focus();
        }, 500);
    };
    renameClose = () => {
        $('.renameVolume_slider').removeClass('active');
    };
    detachClose = () => {
        $('.detach_settngVolume_popup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };
    detachClick = () => {
        $('.detach_settngVolume_popup').addClass('active');
        $("body").addClass("popup_no_scroll");
        document.getElementById('volDetBtn').focus();
        this.setState({ errorMessg: '' });
    };

    createVolClick(param) {
        this.setState({
            isCreate: true, volumeName: '', size: '', attachErrorMessg: "", isYearly: true
            , errorMessg: '', volumeName: '', size: '', attachErrorMessg: '', nameErrorMessg: '', sizeErrorMessg: ''
        });
        if(param === "yearly") {
            $('#existingVolume').removeClass('active');
            $('#createVolume').addClass('active');
        }
        else {

            $('#createMonthlyVolume').addClass('active');
            $('#existingMonthlyVolume').removeClass('active');
        }


    }

    attachExistingVolClick(param) {
        this.setState({
            isCreate: false, selectVolume: '', selectedVolumeId: '', attachErrorMessg: ""
            , errorMessg: '', volumeName: '', size: '', attachErrorMessg: '', nameErrorMessg: '', sizeErrorMessg: ''

        });
        if(param === "yearly") {
            $('#createVolume').removeClass('active');
            $('#existingVolume').addClass('active');
        }
        else {

            $('#createMonthlyVolume').removeClass('active');
            $('#existingMonthlyVolume').addClass('active');
        }


    }
    setTabs = (param) => {
        if(param === "yearly") {
            this.setState({ isYearly: true, isCreate: true, volumeName: '', size: '' });
            $('#existingVolume').removeClass('active');
            $('#createVolume').addClass('active');

        }
        else {
            this.setState({ isYearly: false, isCreate: true, selectVolume: '', selectedVolumeId: '' });
            $('#createMonthlyVolume').addClass('active');
            $('#existingMonthlyVolume').removeClass('active');

        }
        this.setState({ errorMessg: '', volumeName: '', size: '', attachErrorMessg: '', nameErrorMessg: '', sizeErrorMessg: '' });
    };
    render() {
        return (
            <React.Fragment>
                <section className="settingModule_wrapper volume_setting_module">
                    <div className="settModule_head_wrap">
                        <div className="settModule_head_lhs">
                            <h2>Volumes</h2>
                            {/* <p className="head_info">Attach multiple block storage volumes to the instance for persistent data storage</p> */ }
                        </div>
                    </div>
                    <div className="volModule_wrap">
                        <div className="vol_head_wrap">
                            <div className="cta_wrap clearfix">
                                <div className="btn_wrap btnDefaultPad">
                                    <input type="button" name="" value="Add Volume" onClick={ () => this.addVolume() } className={ !this.props.isTaskStateNull ? "common_cta_btn addVol_btn disabled" : "common_cta_btn addVol_btn" } disabled={ !this.props.isTaskStateNull } />
                                </div>
                            </div>
                        </div>
                        <div className="volModule_table_wrap">
                            <div className="tabular_data_wrap">
                                <div className="table_header">
                                    <ul>
                                        <li className="th">
                                            <div className="col col1">
                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("name"); } }>Name<span className="sort_icon active"></span></div>
                                            </div>
                                            <div className="col col2">
                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("size"); } }>Size<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col3">
                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>Created On<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col4">
                                                <div className="header_sort_wrap">Actions</div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="table_data">
                                    <ul>{ this.state.volumeList.length === 0 && !this.state.isAction ? <li><div className="outer_empty_wrap fullPageEmpty">
                                        <div className="inner_empty_wrap">
                                            <div className="svg_wrap empty_icon volumeCreate_empty"></div>
                                            <p className="empty_head">Volumes</p>
                                            <p className="empty_title">Add block storage volumes to expand the storage capacity of your compute instances.</p>
                                            <div className="cta_wrap"> <input type="button" value="Add Volume" className={ !this.props.isTaskStateNull ? "common_cta_btn blue disabled" : "common_cta_btn blue" } disabled={ !this.props.isTaskStateNull } onClick={ () => this.addVolume() } /></div>
                                        </div>
                                    </div> </li> : this.state.volumeList.map((volume, i) =>
                                        <li className="tr" key={ i }>
                                            <div className="col col1"><span data-tip data-for={ volume.name + i }>{ volume.name }</span><ReactToolTip id={ volume.name + i } effect="solid">{ volume.name } </ReactToolTip></div>
                                            <div className="col col2">{ volume.size } GB</div>
                                            <div className="col col3">{ formatDate(volume.created_at) }</div>
                                            <div className="col col4"><span className="menu_icon" onClick={ (e) => this.onRowMenuClick(e, volume) }><span className="svg_wrap" data-tip data-for={ volume.name }><svg className="horizMenuIcon" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                            </svg></span><ReactToolTip id={ volume.name } effect="solid" top="top">Actions</ReactToolTip>
                                                <ul className="dropdown_component volumes_row_options">
                                                    <span className="arrow_pointer"></span>
                                                    {/* <li className="show_config" onClick={(e) => this.showConfiguration(e)}><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                                        <g>
                                                            <path fill="#4C8CCD" d="M9.3,12.9c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S11.2,12.9,9.3,12.9z M9.3,7.6   c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C11,8.4,10.2,7.6,9.3,7.6z"></path>
                                                        </g>
                                                        <g>
                                                            <path fill="#4C8CCD" d="M11.6,18.1c-0.5,0-0.9-0.2-1.2-0.6l-0.9-1.1c-0.3,0-0.5,0-0.8,0l-0.9,1c-0.4,0.5-1.1,0.7-1.8,0.4l-0.9-0.4   c-0.6-0.3-1-0.9-0.9-1.6l0.1-1.4C4.2,14.4,4,14.2,3.8,14l-1.5,0.1c-0.6,0-1.2-0.4-1.4-1l-0.4-0.9c-0.3-0.6-0.1-1.3,0.5-1.8l1.1-0.9   c0-0.3,0-0.5,0-0.8L1,7.9C0.5,7.5,0.3,6.7,0.6,6.1L1,5.2c0.2-0.6,0.8-0.9,1.4-0.9l0.1,0L4,4.5C4.2,4.3,4.3,4.1,4.5,4L4.4,2.5   C4.3,1.8,4.7,1.2,5.3,1l0.9-0.4C6.9,0.3,7.6,0.5,8,1.1L9,2.2c0.2,0,0.4,0,0.6,0l1-1.2c0.4-0.5,1.2-0.7,1.8-0.4l0.9,0.4   c0.6,0.3,1,0.9,0.9,1.6L14,4.1c0.2,0.1,0.3,0.3,0.5,0.5l1.6-0.1c0.6,0,1.2,0.4,1.4,1l0.4,0.9C18.1,7,18,7.7,17.4,8.1L16.3,9   c0,0.2,0,0.5,0,0.7l1.1,0.9c0.5,0.4,0.7,1.2,0.4,1.8l-0.4,0.9c-0.2,0.6-0.8,0.9-1.4,0.9l-0.2,0l-1.4-0.1c-0.2,0.2-0.4,0.4-0.5,0.5   l0.1,1.4c0.1,0.7-0.3,1.3-1,1.6L12.2,18C12,18,11.8,18.1,11.6,18.1z M6.5,16.3C6.5,16.3,6.5,16.3,6.5,16.3L6.5,16.3z M11.5,16.3   C11.5,16.3,11.5,16.3,11.5,16.3L11.5,16.3z M10.3,14.5l1.4,1.7l0.5-0.2L12,13.8l0.4-0.3c0.4-0.3,0.7-0.6,0.9-0.9l0.3-0.4l2.2,0.2   l0.2-0.5l-1.7-1.4l0.1-0.5c0.1-0.4,0.1-0.8,0-1.3l-0.1-0.5l1.8-1.4l-0.2-0.5l-2.3,0.2l-0.3-0.4c-0.3-0.3-0.5-0.6-0.9-0.9l-0.4-0.3   l0.2-2.3l-0.5-0.2l-1.5,1.7L9.9,4.1C9.5,4,9.1,4,8.7,4.1L8.2,4.1L6.7,2.3L6.2,2.6l0.2,2.2L6,5.1C5.6,5.4,5.3,5.7,5.1,6L4.8,6.4   L2.5,6.1L2.3,6.7L4,8.1L3.9,8.6C3.9,9,3.9,9.5,3.9,9.9L4,10.4l-1.7,1.4l0.2,0.5l2.1-0.2l0.3,0.4c0.3,0.4,0.6,0.7,1,1l0.4,0.3   L6,15.9l0.5,0.2L8,14.5l0.5,0.1c0.5,0.1,0.9,0.1,1.4,0L10.3,14.5z M16.2,11.7C16.2,11.7,16.2,11.7,16.2,11.7L16.2,11.7z M2.2,6.8   L2.2,6.8C2.2,6.8,2.2,6.8,2.2,6.8z M12.6,2.7C12.6,2.7,12.6,2.7,12.6,2.7L12.6,2.7z M6.6,2.2C6.6,2.2,6.6,2.2,6.6,2.2L6.6,2.2z"></path>
                                                        </g>
                                                    </svg></span></span>Show Configuration</li> */}
                                                    <li className="rename" onClick={ () => this.renameClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                    </svg></span></span>Rename</li>
                                                    {/* <li className="extend" onClick={() => this.setState({ extendShow: true })}><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M17.3,18.3h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.6L10.6,12l1.4-1.4  l4.3,4.3v-2.6c0-0.6,0.4-1,1-1s1,0.4,1,1v5C18.3,17.8,17.9,18.3,17.3,18.3z M15.3,8.3c-0.6,0-1-0.4-1-1v-3h-3c-0.6,0-1-0.4-1-1  s0.4-1,1-1h4c0.6,0,1,0.4,1,1v4C16.3,7.8,15.9,8.3,15.3,8.3z M7.3,16.3h-4c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v3h3  c0.6,0,1,0.4,1,1S7.9,16.3,7.3,16.3z M6.6,8L2.3,3.7v2.6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1  s-0.4,1-1,1H3.7L8,6.6L6.6,8z"></path>
                                                    </svg></span></span>Extend</li> */}

                                                    {/* <li className="attach" onClick={() => this.setState({ attachShow: true })}><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M2.5,16.5C0,14,0.1,9.7,2.9,6.9l3-3l0,0l2-2c2-2,5.5-2.5,7.4-0.6  c1.9,1.9,1.3,5.2-0.8,7.2l-5.3,5.3c-1.3,1.3-2.8,1.2-4,0s-1.3-2.7,0-4l6-6l1.3,1.3l-6,6c-0.6,0.5-0.5,0.8,0,1.3  c0.5,0.5,0.8,0.5,1.3,0l5.3-5.3c1.3-1.3,2-3.4,0.8-4.5C12.8,1.5,10.5,2,9.2,3.3L3.9,8.6c-2,2-1.9,4.7,0,6.6s4.6,2,6.7,0l6-6l1.3,1.3  l-5.7,5.6C9.4,19,5.1,19.1,2.5,16.5z"></path>
                                                    </svg></span></span>Attach</li> */}
                                                    <li className="detach" onClick={ () => this.detachClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                                        <g>
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M5.2,13.9c1.2,1.2,2.7,1.3,4,0l1.3-1.3l-1.3-1.3l-1.3,1.3   c-0.6,0.5-0.8,0.5-1.3,0c-0.5-0.5-0.6-0.8,0-1.3l1.3-1.3L6.5,8.6L5.2,9.9C3.9,11.2,4,12.7,5.2,13.9z"></path>
                                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="15.2,13.2 17.9,10.6 16.5,9.3 13.9,11.9  "></polygon>
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M7.3,5.2l1.9-1.9C10.5,2,12.8,1.5,14,2.7c1.2,1.2,0.5,3.3-0.8,4.5   l-2,1.9l1.3,1.3l2-1.9c2-2,2.6-5.3,0.8-7.2C13.4-0.5,9.9,0,7.9,2L5.9,3.9L7.3,5.2z"></path>
                                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="11.2,4 8.6,6.6 9.9,7.9 12.5,5.3  "></polygon>
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M11.9,13.9l-1.3,1.3c-2,2-4.8,1.9-6.7,0c-1.9-1.9-2-4.6,0-6.6   l1.3-1.3L3.9,5.9l-1,1C0.1,9.7,0,14,2.5,16.5c2.6,2.6,6.9,2.4,9.7-0.3l1-1L11.9,13.9z"></path>
                                                        </g>
                                                        <rect x="7.8" y="1.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.946 9.1295)" fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" width="1.5" height="18"></rect>
                                                    </svg></span></span>Detach</li>
                                                    {/* <li className="delete" onClick={() => this.setState({ isDeletePopup: true })}><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                    </svg></span></span>Delete</li> */}
                                                </ul>
                                            </span></div>
                                        </li>
                                    ) }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="main_slider createVolume_slider">
                        <div class="slider_bg_shadow"></div>
                        <div class="slider_wrapper">
                            <div class="main_slider_container">
                                <div class="close_icon" onClick={ () => this.addVolumeClose() }></div>
                                <div class="createVol_slide_wrap">
                                    <div class="head_block">
                                        <h2><span class="icon_img"> <span class="icon"></span> </span>Create a new volume</h2>
                                    </div>
                                    <div class="vol_contWrap crVolCont">
                                        <div className="volCreateOptn_radio_wrap" >
                                            <label id="createVolume" className="custom_radio createVol_radio active" onClick={ () => this.createVolClick("yearly") }>Create and attach Volume
                                                <input type="radio" checked={ this.state.isCreate } name="volumeCreate_options" readOnly />
                                                <span className="checkmark"></span> </label>
                                            <label id="existingVolume" className="custom_radio existVol_radio" onClick={ () => this.attachExistingVolClick("yearly") }>Attach existing volume
                                                <input type="radio" checked={ !this.state.isCreate } name="volumeCreate_options" readOnly />
                                                <span className="checkmark"></span> </label>
                                        </div>
                                        <div class="tab_description">
                                            <p class="info_txt">A volume will be created and attached to selected instance.</p>
                                        </div>
                                        <div class="createVol_sec" style={ { display: this.state.isCreate ? 'block' : 'none' } }>
                                            <ul class="volSliderTab">
                                                <li className={ this.state.isYearly ? "volTablist volYearlyList active" : "volTablist volYearlyList" } onClick={ () => {
                                                    this.setTabs("yearly");
                                                } } >Yearly</li>
                                                <li className={ this.state.isYearly ? "volTablist volMonthlyList" : "volTablist volMonthlyList active" } onClick={ () => {
                                                    this.setTabs("monthly");
                                                } }>Monthly</li>
                                            </ul>
                                            <div id="volYearly" class="createVol_content_wrap volYearly" style={ { display: this.state.isYearly ? "block" : "none" } }>
                                                <div class="offer-text-blk">
                                                    <p class="saveoffer-txt"><span class="red-hht-txt">{ this.state.discPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                </div>
                                                <div class="volsliderInnerWrap">
                                                    <div class="createVol_sec">
                                                        <p class="info_txt">Volumes are billed at <span class="old-price">${ (this.state.volPrice * 12).toFixed(2) }</span>/GB/Year <b>${ ((this.state.volPrice * 12) - ((this.state.volPrice * 12) / this.state.discVal)).toFixed(2) }</b>/GB for the first year.</p>
                                                        <p class="info_txt">The size of your volume may range from 1 GB to 1 TB (1000 GB).
                                                            For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB</p>
                                                        <div className="common_txtBox_row">
                                                            <label>Name</label>
                                                            <input id="volumeName" type="text" name="volumeName" value={ this.state.volumeName } onChange={ (e) => this.formHandler(e) } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } autoComplete="off" />
                                                            <span className="comm_error_msg">{ this.state.nameErrorMessg }</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Size<span className="moreInfo">&nbsp;&nbsp;</span></label>
                                                            <div className="txtBox_wrap">
                                                                <input type="text" id="size" name="size" value={ this.state.size } placeholder="Enter a volume size between 1 GB to 1000 GB"
                                                                    autoComplete="off" onChange={ (e) => this.formHandler(e) } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } />
                                                                <span className="label_unit">GB</span>
                                                            </div>
                                                            <span className="comm_error_msg">{ this.state.sizeErrorMessg }</span>
                                                            {/* <label style={{display:'block'}}>Enter a volume size greater than 10 GB</label> */ }
                                                        </div>
                                                        <div class="cta_wrap">
                                                            <input type="button" name="" value="Create Volume" onClick={ () => this.createAndAttachVolume() } className="common_cta_btn blue" />
                                                            <input type="button" name="" value="Cancel" onClick={ () => this.addVolumeClose() } className="common_cta_btn transparentGrey" />
                                                        </div>
                                                        <div class="common_txtBox_row" style={ { display: "block" } }>
                                                            <b>Note:</b>
                                                            <p>- The { this.state.discPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</p>
                                                            <p>- Any charges incurred for the volume will not be refunded on deleting the volume.</p>
                                                            <p>- To add a volume greater than 1000 GB,
                                                                <a href="https://www.idrivecompute.com/support.htm" target="_blank"> contact support</a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="volMonthly" class="createVol_content_wrap volMonthly" style={ { display: this.state.isYearly ? "none" : "block" } }>
                                                <div class="offer-text-blk">
                                                    <p class="saveoffer-txt">Pay as you use with monthly plan</p>
                                                </div>
                                                <div class="volsliderInnerWrap">
                                                    <p class="info_txt">Volumes are billed per month at <b>${ this.state.volPrice }/GB</b>.</p>
                                                    <p class="info_txt">The size of your volume may range from 1 GB to 1 TB (1000 GB).
                                                        For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB</p>
                                                    <div className="common_txtBox_row">
                                                        <label>Name</label>
                                                        <input id="volumeName" type="text" name="volumeName" value={ this.state.volumeName } onChange={ (e) => this.formHandler(e) } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } autoComplete="off" />
                                                        <span className="comm_error_msg">{ this.state.nameErrorMessg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Size<span className="moreInfo">&nbsp;&nbsp;</span></label>
                                                        <div className="txtBox_wrap">
                                                            <input type="text" id="size" name="size" value={ this.state.size } placeholder="Enter a volume size between 1 GB to 1000 GB"
                                                                autoComplete="off" onChange={ (e) => this.formHandler(e) } className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'addvolume') } />
                                                            <span className="label_unit">GB</span>
                                                        </div>
                                                        <span className="comm_error_msg">{ this.state.sizeErrorMessg }</span>
                                                        {/* <label style={{display:'block'}}>Enter a volume size greater than 10 GB</label> */ }
                                                    </div>
                                                    <div class="cta_wrap">
                                                        <input type="button" name="" value="Create Volume" onClick={ () => this.createAndAttachVolume() } className="common_cta_btn blue" />
                                                        <input type="button" name="" value="Cancel" onClick={ () => this.addVolumeClose() } className="common_cta_btn transparentGrey" />
                                                    </div>
                                                    <div class="common_txtBox_row" style={ { display: "block" } }><b>Note:</b> To add a volume greater than 1000 GB, <a href="https://www.idrivecompute.com/support.htm" target="_blank"> Contact support</a></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="existVol_sec" style={ { display: this.state.isCreate ? 'none' : 'block' } }>
                                            <div className="common_txtBox_row">
                                                <label>Volume</label>
                                                <div className="custom_select_box"  >
                                                    <select name='selectVolume' value={ this.state.selectedVolumeId } onChange={ (e) => this.formHandler(e) } >
                                                        { this.state.selectVolumeList.length === 0 ? <option value='' default>No volume available</option> : <option value='' style={ { display: 'none' } } default>Select a volume</option> }
                                                        { this.state.selectVolumeList.length > 0 && this.state.selectVolumeList.map((elem, j) =>
                                                            <option key={ j } value={ elem.id } >{ elem.name }</option>
                                                        ) }
                                                    </select>
                                                </div>
                                                <span className="comm_error_msg">{ this.state.attachErrorMessg }</span>
                                                {/* <p className="info_txt"></p> */ }
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Submit" onClick={ () => this.attachVolumetoInstance(undefined) } className="common_cta_btn blue" />
                                                <input type="button" name="" value="Cancel" onClick={ () => this.addVolumeClose() } className="common_cta_btn transparentGrey" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main_slider renameVolume_slider">
                        <div className="slider_bg_shadow"></div>
                        <div className="slider_wrapper">
                            <div className="main_slider_container">
                                <div className="close_icon" onClick={ () => this.renameClose() }></div>
                                <div className="createVol_slide_wrap">
                                    <div className="head_block">
                                        <h2><span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                        </svg></span>Rename</h2>
                                    </div>
                                    <div className="createVol_content_wrap">
                                        <div className="common_txtBox_row">
                                            <label>Name</label>
                                            <input type="text" id="renameName" name="renameName" value={ this.state.renameName } onChange={ this.formHandler }
                                                autoComplete="off" className="txt_box" onKeyDown={ (e) => this.onVolKeydown(e, 'rename') } placeholder="Provide a new name for the volume" />
                                            <span className="comm_error_msg">{ this.state.errorMessg }</span>
                                            <span className="comm_error_msg">{ this.state.nameErrorMessg }</span>
                                        </div>
                                        <div className="cta_wrap">
                                            <input type="button" name="" value="Save" className="common_cta_btn blue" onClick={ () => this.renameVolume() } />
                                            <input type="button" name="" value="Cancel" onClick={ () => this.renameClose() } className="common_cta_btn transparentGrey" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={ this.state.extendShow ? "main_slider extendVolume_slider active" : "main_slider extendVolume_slider" } style={ { display: 'none' } }>
                        <div className="slider_bg_shadow"></div>
                        <div className="slider_wrapper">
                            <div className="main_slider_container">
                                <div className="close_icon" onClick={ () => this.setState({ extendShow: false }) }></div>
                                <div className="createVol_slide_wrap">
                                    <div className="head_block">
                                        <h2><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve">
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M17.3,18.3h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.6L10.6,12l1.4-1.4  l4.3,4.3v-2.6c0-0.6,0.4-1,1-1s1,0.4,1,1v5C18.3,17.8,17.9,18.3,17.3,18.3z M15.3,8.3c-0.6,0-1-0.4-1-1v-3h-3c-0.6,0-1-0.4-1-1  s0.4-1,1-1h4c0.6,0,1,0.4,1,1v4C16.3,7.8,15.9,8.3,15.3,8.3z M7.3,16.3h-4c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v3h3  c0.6,0,1,0.4,1,1S7.9,16.3,7.3,16.3z M6.6,8L2.3,3.7v2.6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1  s-0.4,1-1,1H3.7L8,6.6L6.6,8z"></path>
                                        </svg></span>Extend's volume size</h2>
                                    </div>
                                    <div className="createVol_content_wrap">
                                        <span className="comm_error_msg" >{ this.state.errorMessg } </span>
                                        <div className="common_txtBox_row">
                                            <label>Size(GB)<span className="moreInfo">&nbsp;-&nbsp;enter a multiple of 1 GB</span></label>
                                            <div className="txtBox_wrap">
                                                <input type="text" name="extendVolume" value={ this.state.extendVolume } onChange={ this.formHandler }
                                                    autoComplete="off" className="txt_box" placeholder={ this.state.selectedVolume.size } />
                                                <span className="label_unit">GB</span> </div>
                                            <p className="info_txt"></p>
                                        </div>
                                        {/* <div className="common_txtBox_row">
                                            <label>Total Cost</label>
                                            <input type="text" name="" value="$ 17.50/mo" className="txt_box totl_cost" placeholder="" disabled="" />
                                        </div> */}
                                        <div className="cta_wrap">
                                            <input type="button" name="" value="Extend" onClick={ () => this.extendVolumeSize() } className="common_cta_btn blue" />
                                            <input type="button" name="" value="Cancel" onClick={ () => this.setState({ extendShow: false }) } className="common_cta_btn transparentGrey" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </section>
                <div className="main_popup detach_settngVolume_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" onClick={ () => this.detachClose() } data-toggle="tooltip" title="" data-original-title="Close"></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Detach <span className="volName"><b>{ this.state.selectedVolume.name }</b> </span></div>
                                </div>
                                <div className="popup_body">
                                    <p className="imp_warn_note"><strong>Warning:</strong> This will detach the volume from the instance it is attached to. On detaching the volume from the current instance, you cannot access the volume and the data stored in it without attaching it to another instance.</p>
                                    <p>Are you sure you want to detach the <b>{ this.state.selectedVolume.name }</b> from <b>{ this.props.instance.name }</b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button id="volDetBtn" className="btn btn_confirm" onClick={ () => this.detachInstance() }>Detach</button>
                                        <button className="btn btn_cancel" onClick={ () => this.detachClose() }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ this.state.isDeletePopup ? "main_popup delete_volume_popup active" : "main_popup delete_volume_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span onClick={ () => this.setState({ isDeletePopup: false }) } className="close_icon" data-toggle="tooltip" title="" data-original-title="Close"></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to delete your <b>{ this.state.selectedVolume.name }</b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button id="volDelBtn" className="btn btn_confirm" onClick={ () => this.deleteVolumeById() }>Delete</button>
                                        <button className="btn btn_cancel" onClick={ () => this.setState({ isDeletePopup: false }) }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
function formatDate(dt) {
    if(!dt.includes('Z')) {
        dt = dt + 'Z';
    }
    let d = new Date(dt);
    return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
}
export default Volumes;